export const TERMS_LAST_UPDATED = "April 19, 2026";
export const TERMS_EFFECTIVE_DATE = "April 19, 2026";
// Bump this whenever the Terms of Service is materially updated.
// Used as the durable record of which version a user accepted in
// `public.terms_acceptances.terms_version`.
export const TERMS_VERSION = "2026-04-19";

export interface TermsSection {
  id: string;
  title: string;
}

export const TERMS_SECTIONS: TermsSection[] = [
  { id: "agreement", title: "1. Agreement to These Terms" },
  { id: "eligibility", title: "2. Eligibility" },
  { id: "accounts", title: "3. Accounts & Security" },
  { id: "license", title: "4. License to Use the Service" },
  { id: "user-content", title: "5. Your Content & License Grant" },
  { id: "acceptable-use", title: "6. Acceptable Use Policy" },
  { id: "ai-disclaimer", title: "7. AI-Assisted Spiritual Guidance" },
  { id: "not-advice", title: "8. Not Professional or Religious Advice" },
  { id: "third-party", title: "9. Third-Party Services" },
  { id: "ip", title: "10. Intellectual Property" },
  { id: "dmca", title: "11. DMCA & Copyright Complaints" },
  { id: "payments", title: "12. Subscriptions & Billing" },
  { id: "trials-refunds", title: "13. Free Trials & Refunds" },
  { id: "termination", title: "14. Termination & Suspension" },
  { id: "privacy", title: "15. Privacy" },
  { id: "warranties", title: "16. Disclaimers of Warranties" },
  { id: "liability", title: "17. Limitation of Liability" },
  { id: "indemnification", title: "18. Indemnification" },
  { id: "arbitration", title: "19. Arbitration & Class Action Waiver" },
  { id: "governing-law", title: "20. Governing Law & Venue" },
  { id: "miscellaneous", title: "21. General Provisions" },
  { id: "changes", title: "22. Changes to These Terms" },
  { id: "contact", title: "23. Contact" },
];
